interface Socket {
    close: (code: number, reason: string) => void;
}

export interface ExtraProps {
    socket: Socket;
    token: string;
    connectionTimeout?: ReturnType<typeof setTimeout>;
}

export interface CustomConnectionParams extends Record<string, unknown> {
    token: string;
}
